import React from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import FeedbackForm from "./feedbackComponents/FeedbackForm";

import {
  useGetFeedbackDetailQuery,
  useUpdateFeedbackMutation,
} from "store/services/feedbackApi";

import { useAppMeta } from "hooks";

const FeedbackEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Feedbacks", path: "/app/crm/feedback/list" },
    { title: "Edit Feedback" },
  ];

  // RTK Query
  const {
    data: feedbackDetail,
    isLoading: loadingFeedbackDetail,
    error,
  } = useGetFeedbackDetailQuery(id);

  const [updateFeedback, { isLoading: updatingFeedback }] =
    useUpdateFeedbackMutation();

  // methods
  const handleUpdateFeedback = async (data) => {
    try {
      await updateFeedback(data).unwrap();
      toast.success("Feedback successfully updated!");
      navigate(`/app/crm/feedback/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update feedback!");
    }
  };

  useAppMeta("Edit Feedback");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={updatingFeedback || loadingFeedbackDetail}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <FeedbackForm
          feedbackDetail={feedbackDetail}
          onSubmit={handleUpdateFeedback}
          isBusy={updatingFeedback || loadingFeedbackDetail}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default FeedbackEditScreen;
